import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import CardItem from "./CardItem"
import Paginator from "components/Common/Paginator/Paginator"
import AdminsService from "services/Admin/AdminsService" 
import ModalForm from "./ModalForm";
import FilterForm from "./FilterForm"
import FilterIcon from "assets/images/filter.png"
import SuccessModal from "components/SucessModal"
import { useSelector } from "react-redux"
import "./Style.scss"

const AdminsPage = () => {
  const AuthData = useSelector(state => state.Auth)
  const [modal, setModal] = useState(false);
  const [editAdmin, setEditAdmin] = useState(null)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const adminsService = new AdminsService()
  const [list, setList] = useState([])
  const [showFilters, setShowFilters] = useState(false)
  const [searchWord, setSearchWord] = useState("")
  const [active, setActive] = useState("all");
  const [roleId, setRolId] = useState(null)
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false) 
  const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
  const toggleModal = () =>  setModal(!modal)
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  });

  const addHandler = () => {
    setEditAdmin(null)
    toggleModal()
  }
  
  const updateHandler = (item) => {
    toggleModal()
    setEditAdmin(item)
  }

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)
  }


  useEffect(() => {
    // debounce solution to reduce request data from api
    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord
      if (roleId?.length !==0) params['role_ids'] = roleId?.map(role=>role.value).join()
       setFilterParams({ ...params })
    }, 1000) 

    return () => clearTimeout(timeoutId)

  }, [active, searchWord,roleId])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Admins</title>
        </MetaTags>
        <Container fluid>
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Admins</h4>
             </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="form-group has-search pb-2">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text" className="form-control" placeholder="Search by admin name, I.D" onChange={(e) => OnSearchChange(e)}
                  value={searchWord} />
              </div>
            </Col>
            {isExist("admins.add") ? <Col md={6}>
              <div className="d-flex justify-content-md-end removebtnhover">
                <button className="btn btn-success btnHeight px-4" onClick={addHandler}>Invite Admin</button>
                {modal && (
                  <ModalForm
                    modal={modal}
                    toggle={toggleModal}
                     editAdmin={editAdmin}
                    setEditAdmin={setEditAdmin}
                    setShouldGetData={setShouldGetData}
                    setShowSuccessModal={setShowSuccessModal}


                  />
                )}
              </div>
            </Col>:null}

          </Row>
          <Row className="my-4 d-flex justify-content-between" >
            <Col md={6} sm={8} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all");
                }}
              >
                All
                </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active");
                }}
              >
                Active
                </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive");
                }}
              >
                Deactive
                </button>
            </Col>
            <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">

              <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                setShowFilters(!showFilters)
              }}> <img src={FilterIcon} style={{marginRight:"5px"}}/>Filter</button>
            </Col>

          </Row>
          {showFilters ?<FilterForm
            showFilters={showFilters}
            setRolId={setRolId}
            roleId={roleId}
            toggle={()=>setShowFilters(!showFilters)}
          />:null}
          <div>
            <Card className="w-100 mt-4">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-16'>I.D</th>
                            <th className='font-size-16'>Name</th>
                            <th className='font-size-16'>Email</th>
                            <th className='font-size-16'>Role</th>
                            <th className='font-size-16'>Invitation Sender</th>
                            <th className='font-size-16'>Status</th>
                            <th className='font-size-16'></th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.map((item, index) => <CardItem
                            key={index}
                            index={index}
                            {...item}
                             item={item}
                            Service={AdminsService}
                            updateHandler={() => updateHandler(item)}
                            setShouldGetData={setShouldGetData}

                          />)}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-between" md={12} sm={12}>
            <Paginator
              service={adminsService}
              pageOptions={pageOptions}
              setData={(data) => setList([...data])}
              setPageOptions={setPageOptions}
              filtersParams={filtersParams}
              shouldGetData={shouldGetData}
              setShouldGetData={setShouldGetData}
            />
            </Col>
            </Row >
          </div>
          {showSuccessModal && <SuccessModal
                        modal={showSuccessModal}
                        title={"Assign An Admin"}
                        subtitle={"Assign an admin to can manage the properties and sales rep"}
                        message={"The invitation  sent successfully "}
                        onClick={() => {
                            setShowSuccessModal(false)
                        }} />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AdminsPage;